/* Serena — section main : galerie (slider scroll-snap + miniatures) et ajout au panier (offres sans app).
   Contrat panier : POST routes.cart_add_url + '.js' puis evenement document « serena:cart:open ». */
(function () {
  if (!customElements.get('serena-main-gallery')) {
    class SerenaMainGallery extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.list = this.querySelector('[data-slides]');
        this.thumbs = this.querySelector('[data-thumbs]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.slides = Array.from(this.querySelectorAll('.sm-slide'));
        this.items = Array.from(this.querySelectorAll('.sm-thumb-item'));
        this.step = parseInt(this.dataset.step, 10) || 3;
        this.current = 0;

        this.items.forEach((item, i) => {
          item.querySelector('.sm-thumb').addEventListener('click', () => this.goTo(i));
        });
        this.prev.addEventListener('click', () => this.slideThumbs(-1));
        this.next.addEventListener('click', () => this.slideThumbs(1));
        this.list.addEventListener('scroll', () => {
          clearTimeout(this._t);
          this._t = setTimeout(() => this.syncFromScroll(), 80);
        }, { passive: true });
        this.thumbs.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons());
        this.updateButtons();
      }
      pitch(el, list) {
        return list.length > 1 ? list[1].offsetLeft - list[0].offsetLeft : el.clientWidth;
      }
      goTo(i) {
        const slide = this.slides[i];
        if (!slide) return;
        this.list.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
        this.setCurrent(i);
      }
      syncFromScroll() {
        const p = this.pitch(this.list, this.slides) || 1;
        const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.list.scrollLeft / p)));
        if (i !== this.current) this.setCurrent(i, true);
      }
      setCurrent(i, fromScroll) {
        this.current = i;
        this.slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        this.items.forEach((it, k) => {
          const b = it.querySelector('.sm-thumb');
          if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
        const it = this.items[i];
        if (it) {
          const left = it.offsetLeft - this.items[0].offsetLeft;
          const view = this.thumbs.scrollLeft;
          const w = this.thumbs.clientWidth;
          if (left < view || left + it.offsetWidth > view + w) {
            this.thumbs.scrollTo({ left: Math.max(0, left - (w - it.offsetWidth) / 2), behavior: 'smooth' });
          }
        }
      }
      slideThumbs(dir) {
        const p = this.pitch(this.thumbs, this.items);
        this.thumbs.scrollBy({ left: dir * this.step * p, behavior: 'smooth' });
      }
      updateButtons() {
        const max = this.thumbs.scrollWidth - this.thumbs.clientWidth;
        this.prev.disabled = this.thumbs.scrollLeft <= 1;
        this.next.disabled = this.thumbs.scrollLeft >= max - 1;
      }
    }
    customElements.define('serena-main-gallery', SerenaMainGallery);
  }

  if (!customElements.get('serena-main-buy')) {
    class SerenaMainBuy extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.btn = this.querySelector('[data-atc]');
        this.errBox = this.querySelector('[data-error-box]');
        this.errText = this.querySelector('[data-error-text]');
        this.btn.addEventListener('click', () => this.add());
      }
      offer() {
        const r = this.querySelector('input[type="radio"]:checked');
        return r ? r.value : '1';
      }
      showError(msg) {
        this.errText.textContent = msg || this.dataset.error || '';
        this.errBox.classList.add('is-visible');
      }
      async add() {
        if (this.btn.disabled) return;
        const offer = this.offer();
        const variant = parseInt(this.dataset.variant, 10);
        const gift = parseInt(this.dataset.giftVariant, 10);
        const items = [{ id: variant, quantity: 1, properties: { _serena_offre: offer } }];
        if (offer === '2' && gift) {
          items.push({ id: gift, quantity: 1, properties: { _serena_offre: '2', _serena_cadeau: '1' } });
        }
        this.errBox.classList.remove('is-visible');
        this.btn.disabled = true;
        try {
          const res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!res.ok) {
            let msg;
            try { const j = await res.json(); msg = j.description || j.message; } catch (e) {}
            this.showError(msg);
            return;
          }
          document.dispatchEvent(new CustomEvent('serena:cart:open', { detail: { refresh: true } }));
        } catch (e) {
          this.showError();
        } finally {
          this.btn.disabled = false;
        }
      }
    }
    customElements.define('serena-main-buy', SerenaMainBuy);
  }
})();
